import React from 'react';
import PageHero from '../components/PageHero';
import PackagesSection from '../components/Packages';
import ReferralBanner from '../components/ReferralBanner';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';

export default function PackagesPage() {
  return (
    <>
      <PageHero
        eyebrow="Programme options"
        title="Pick a starting point. A doctor confirms what's right for you."
        subtitle="Plans below are illustrative. Final dosage, fees and prescription decisions are made by a licensed doctor after reviewing your assessment. Medication, where prescribed, is dispensed by licensed pharmacy partners."
      />

      <Reveal><PackagesSection /></Reveal>

      <section className="bg-white">
        <div className="container-x pb-16">
          <Reveal><ReferralBanner /></Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
